/**
 * @Author: DJ
 * @Date:   2021-09-03 11:25:02
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-03 16:21:39
 */
import { createModel } from '@/store/tools';

const model = {
    namespace: 'microshippingorder',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getDeliveryOrderDetail': T('getDeliveryOrderDetail'), // 获取配送订单详情
            'getDeliveryOrderList': T('getDeliveryOrderList'), // 获取配送订单列表
            'getDeliveryOrderStatus': T('getDeliveryOrderStatus'), // 获取订单状态
            'getDeliveryStatusUpdateLog': T('getDeliveryStatusUpdateLog'), // 获取操作日志
            'getOrderDeliveryTypeEnum': T('getOrderDeliveryTypeEnum'), // 获取订单类型
            'getCompanyItem': T('getCompanyItem'), // 获取运营公司
            'getDeliveryGroupList': T('getDeliveryGroupList'), // 一路多单列表
            'getDeliveryGroupDetail': T('getDeliveryGroupDetail'), // 一路多单订单详情
            'getlistAssignRider': T('getlistAssignRider'), // 指派订单列表
            'getKnightLevel': T('getKnightLevel'), // 骑士等级下拉
        },
        actions: {
             'getDeliveryOrderDetail': A('getDeliveryOrderDetail'), // 获取配送订单详情
             'getCleanDetail': C('getDeliveryOrderDetail'), // 管理清除详情数据
             'getDeliveryOrderList': A('getDeliveryOrderList'), // 获取配送订单列表
             'getDeliveryOrderStatus': A('getDeliveryOrderStatus'), // 获取订单状态
             'getDeliveryStatusUpdateLog': A('getDeliveryStatusUpdateLog'), // 获取操作日志
             'getOrderDeliveryTypeEnum': A('getOrderDeliveryTypeEnum'), // 获取订单类型
             'getCompanyItem': A('getCompanyItem'), // 获取运营公司
             'getDeliveryGroupList': A('getDeliveryGroupList'), // 一路多单列表
             'getDeliveryGroupDetail': A('getDeliveryGroupDetail'), // 一路多单订单详情
             'getlistAssignRider': A('getlistAssignRider'), // 指派订单列表
             'getKnightLevel': A('getKnightLevel'), // 骑士等级下拉
        },
        sagas: {
            'getDeliveryOrderDetail': S('getDeliveryOrderDetail', '/?cmd=com.xqxc.api.pig.mis.order.MisMicroOrderDeliveryService.getDeliveryDetail'),
            'getDeliveryOrderList': S('getDeliveryOrderList', '/?cmd=com.xqxc.api.pig.mis.order.MisMicroOrderDeliveryService.getDeliveryList'),
            'getDeliveryOrderStatus': S('getDeliveryOrderStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getDeliveryStatusUpdateLog': S('getDeliveryStatusUpdateLog', '/?cmd=com.xqxc.api.pig.mis.order.DeliveryOrderManageMisService.getDeliveryStatusUpdateLog'),
            'getOrderDeliveryTypeEnum': S('getOrderDeliveryTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getCompanyItem': S('getCompanyItem', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.companyItem'),
            'getDeliveryGroupList': S('getDeliveryGroupList', '/?cmd=com.xqxc.api.pig.mis.order.DeliveryOrderManageMisService.getDeliveryGroupList'),
            'getDeliveryGroupDetail': S('getDeliveryGroupDetail', '/?cmd=com.xqxc.api.pig.mis.order.DeliveryOrderManageMisService.getDeliveryGroupDetail'),
            'getlistAssignRider': S('getlistAssignRider', '/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.listAssignRider'),
            'getKnightLevel': S('getKnightLevel', '/?cmd=com.xqxc.api.pig.mis.biz.account.AcRiderLevelMisService.list'),
        },
        reducers: {
            'DeliveryOrderDetail': R('getDeliveryOrderDetail', {}),
            'DeliveryOrderList': R('getDeliveryOrderList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'DeliveryOrderStatus': R('getDeliveryOrderStatus', []),
            'DeliveryStatusUpdateLog': R('getDeliveryStatusUpdateLog', []),
            'OrderDeliveryTypeEnum': R('getOrderDeliveryTypeEnum', []),
            'CompanyItem': R('getCompanyItem', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'DeliveryGroupList': R('getDeliveryGroupList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'DeliveryGroupDetail': R('getDeliveryGroupDetail', {}),
            'listAssignRider': R('getlistAssignRider', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'KnightLevel': R('getKnightLevel', []),
        }
    })
};
export default createModel(model);